import { useMutation } from '@tanstack/react-query'
import { useCogfy } from './use-cogfy'
import { UUID } from '@indigohive/cogfy-types'

export function useGenerateChatAppId (fieldId: UUID) {
  const cogfy = useCogfy()

  return useMutation({
    mutationKey: ['generateChatAppId', fieldId],
    mutationFn: async () => await cogfy.generateChatAppId({
      fieldId
    })
  })
}
